import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

function AddSnippet( {languageOptions} ) {
    const [language, setLanguage] = useState('');
    const [code, setCode] = useState('');
    const [keywords, setKeywords] = useState('');
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        const token = localStorage.getItem('token'); // Ensure token is stored after login

        try {
            const response = await axios.post(
                'https://api.jimmybauduin.com/snippets',
                { language, code, keywords },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            console.log('Snippet added:', response.data);
            // Optionally, redirect or update state
            // navigate('/'); // Redirect to home after adding
        } catch (err) {
            console.error('Error adding snippet:', err);
            setError('Failed to add snippet. Please try again.');
        }
    };

    return (
        <Row className="mt-4 text-center">
            <Col xs={12} md={4} className="mx-auto">
                <h2>Add a New Snippet</h2>
                {error && <p style={{ color: 'red' }}>{error}</p>}
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="formLanguage">
                        <Form.Label>Language</Form.Label>
                        <Form.Select 
                            aria-label="Language choice"
                            value={language} 
                            onChange={(e) => setLanguage(e.target.value)} 
                            required
                        >
                            <option value="">Select language</option>
                            {languageOptions.map((language, index) => (
                                <option value={language.name} key={index}>
                                    {language.name}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formCode">
                        <Form.Label>Code</Form.Label>
                        <Form.Control 
                            as='textarea' 
                            rows={3} 
                            value={code} 
                            onChange={(e) => setCode(e.target.value)} 
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formKeywords">
                        <Form.Label>Keywords (separated by semicolons)</Form.Label>
                        <Form.Control 
                            type='text' 
                            value={keywords} 
                            onChange={(e) => setKeywords(e.target.value)}
                            placeholder="e.g., react;hooks;state"
                        />
                    </Form.Group>
                    <Button type='submit' variant='secondary'>
                        Add Snippet
                    </Button>
                </Form>
            </Col>
        </Row>
    );
}

export default AddSnippet;
